import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import classes from '../Assist.css';

import axios from 'axios';
import Alert from 'react-s-alert';
import { useMobile, authEndpoint } from '../../../store/utility';

class Assist extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            emailConfirmationSucceeded: false
        }
    }

    handleConfirm = () => {
        let url = authEndpoint + 'api/v1/rest-auth/registration/verify-email/';
            let requestPasswordResetData = {
                key: this.props.match.params.key
            }
            axios.post(url, requestPasswordResetData)
                .then(response => {
                    Alert.success(response.data.detail);
                    this.setState({emailConfirmationSucceeded: true});
                })
                .catch(err => {
                    Alert.error('Email verification failed, please try again later');
        });
    }

    handleContinue = () => {
        window.location = '/auth/login/';
    }

    render(){

        let displaySize;
        if (useMobile()===true) {
            displaySize = 'none';
        }
        else {
            displaySize = 'none';
        }

        let confirmEmailPendingView = (
            <div>
            <Row>
                <Col>
                    <div className={classes.Title}>
                    Thank you for joining BookMeeY.
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className={classes.Button}>
                    <Button variant="info" size={displaySize} onClick={this.handleConfirm} >Confirm Email</Button>
                    </div>
                </Col>
            </Row>
            </div>
        )
        
        let confirmEmailConfirmedView = (
            <div>
                <Row>
                    <Col>
                        <div className={classes.Title}>
                        Your email is confirmed.
                        </div>
                    </Col>
                </Row>
                <Row>
                <Col>
                    <div className={classes.Button}>
                    <Button variant="info" size={displaySize} onClick={this.handleContinue} >Continue to Sign In</Button>
                    </div>
                </Col>
                </Row>
            </div>
        )

        
        let confirmEmailView;
        if (this.state.emailConfirmationSucceeded === true) {
            confirmEmailView = confirmEmailConfirmedView;
        }
        else {
            confirmEmailView = confirmEmailPendingView;
        }

        return (

            <div className={classes.Assist}>
                <Container>
                    {confirmEmailView}
                </Container>
            </div>
        );
    }
}

export default Assist;


// WEBPACK FOOTER //
// ./src/containers/Assist/ConfirmEmail/ConfirmEmail.js